export const getYTicks = (maxThreshold: number) => {
  if (maxThreshold <= 10) {
    return Array.from({ length: maxThreshold + 1 }, (_, i) => i)
  } else if (maxThreshold <= 30) {
    const ticks = []
    for (let i = 0; i <= maxThreshold; i += Math.ceil(maxThreshold / 6)) {
      ticks.push(i)
    }
    if (ticks[ticks.length - 1] !== maxThreshold) {
      ticks.push(maxThreshold)
    }
    return ticks
  } else {
    const ticks = []
    const interval = Math.ceil(maxThreshold / 6)
    for (let i = 0; i <= maxThreshold; i += interval) {
      ticks.push(i)
    }
    if (ticks[ticks.length - 1] !== maxThreshold) {
      ticks.push(maxThreshold)
    }
    return ticks
  }
}
